export default __webpack_public_path__ + "static/touch-icon-114-acaa28a9fb760a5a849412d0998da856.png";